import { DataTableSearchInput } from 'design-system';

import { captureEvent } from '@/services/analytics';
import { useFilter } from '../../../state/useFilter';

const TableSearch = ({ tabId }: { tabId: string }) => {
  const { filters, setFilter } = useFilter();

  return (
    <DataTableSearchInput
      aria-label='Search catalog'
      commitOn={['click', 'keydown']}
      id={tabId}
      mode='controlled'
      placeholder='Search codes, titles...'
      value={filters.search ?? ''}
      wait={700}
      onCommit={value => {
        if (value.trim()) {
          captureEvent('gxgo_text_field_submitted', { id: tabId, searchValue: value });
        }
      }}
      onValueChange={value => setFilter('search', value || null)}
    />
  );
};

export default TableSearch;
